import { useCallback } from "react";
import { useSelector } from "react-redux";
import { SEARCH_TYPES } from "../../../../../store/reducer/_searchReducer";
import {
  getLoading,
  getSearchResults,
  getSearchResultsType,
} from "../../../../../store/selectors";

import LexLoading from "../../../global/_lexLoading";
import BlocoResultados from "../_blocoResultado";
import SemResultados from "../_semResultados";
import "./index.scss";

const ListOfResults = () => {
  const searchResults = useSelector(getSearchResults);
  const searchResultsType = useSelector(getSearchResultsType);
  const isLoading = useSelector(getLoading);
  const isTudo = searchResultsType?.toLowerCase() === "all";

  const renderResults = useCallback(() => {
    if (isLoading) {
      return (
        <div className="loading-content">
          <LexLoading customText="Buscando resultados..." />
        </div>
      );
    }

    const hasResults =
      isTudo &&
      Object.values(searchResults).some((value) => value?.results?.length > 0);

    const noResults = isTudo
      ? !hasResults
      : !searchResults[searchResultsType]?.results?.length;

    return noResults ? (
      <SemResultados />
    ) : (
      Object.keys(SEARCH_TYPES)
        .filter((key) => (isTudo ? key !== "all" : key === searchResultsType))
        .map((key) => <BlocoResultados key={key} tipo={key} />)
    );
  }, [isLoading, isTudo, searchResults, searchResultsType]);

  return (
    <div className="pdl_components_lista_resultados">{renderResults()}</div>
  );
};

export default ListOfResults;
